
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.641 25.235c-.138-.066-.292-.053-.437-.088-.62-.15-1.198-.377-1.62-.884C.14 23.727.06 23.11.292 22.478c.227-.616.75-.942 1.371-1.04.96-.151 1.682.279 2.034 1.156.12.299.238.601.476.834.328.317.725.278.963-.11.16-.269.242-.576.238-.888.002-5.118.002-10.236 0-15.354a.598.598 0 00-.601-.606c-.284-.005-.57 0-.853 0a.944.944 0 01-.915-.757.919.919 0 01.625-1.04 1.49 1.49 0 01.488-.06h7.99c.447 0 .658-.147.818-.57.16-.423.59-.697 1.1-.699h12.59c.297 0 .297 0 .298.296V5.03c0 .25 0 .25-.259.25h-3.291c-.555 0-.853.302-.853.858v11.625c0 .504-.182.892-.627 1.174-1.25.794-2.487 1.61-3.727 2.416-.082.056-.17.102-.261.14-.509.194-.976-.106-1.015-.65-.005-.073 0-.146 0-.219V6.4c0-.12-.008-.238-.024-.355-.068-.514-.344-.761-.862-.765-.62-.005-1.242 0-1.863 0-.424 0-.61.135-.755.53a.998.998 0 01-.946.659c-.192.004-.383 0-.575 0a.59.59 0 00-.61.595v11.724a3.154 3.154 0 01-.555 1.847c-.282.402-.67.69-1.07.96-1.31.883-2.632 1.75-3.936 2.644-.656.45-1.348.802-2.135.94-.127.021-.262-.02-.381.055H2.64zM27.704 10.451c0-2.28-.001-4.562-.004-6.844 0-.188.045-.244.238-.243 1.738.008 3.477.008 5.215 0 .18 0 .216.052.216.222-.005 3.617-.007 7.234-.005 10.851 0 .5-.178.895-.625 1.179-1.262.801-2.51 1.625-3.763 2.438a.913.913 0 01-.422.16c-.486.04-.77-.216-.84-.761a1.855 1.855 0 01-.01-.238V10.45zM30.52.238h2.141a.892.892 0 01.912.834c.036.531-.279.927-.793.997a2.22 2.22 0 01-.295.023h-3.96c-.342 0-.656-.07-.865-.38-.21-.309-.247-.639-.08-.973a.848.848 0 01.8-.501h2.14z","fill":"#748190"}})])
          )
        }
      }
    